// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"22d23f22","952":"6ac4a3db"}[chunkId] + ".chunk.js";
};